import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useTheme, useToast } from "@/comn/hooks";
import { APIS, SF_ROLE_MGMT_SRCH, SG_ROLE_MGMT_LIST, URLS } from "@/tra/tancis/ptli/ptl/role/services/PtliRoleService";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

/*
 * Select Role Management List
 * !== 역할 관리 목록 ==!
 */
export const PTLI1004001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const { theme } = useTheme();
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
            { area: "roleCd" },
        ],
    });

    const form = {
        roleSrch: useForm({ defaultSchema: SF_ROLE_MGMT_SRCH }),
    };

    const grid = {
        roleList: useGrid({
            defaultSchema: SG_ROLE_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getRoleList: useFetch({
            api: (page = grid.roleList.page) => APIS.getRoleList(form.roleSrch.getValues(), page, grid.roleList.size),
            enabled: comnUtils.isEmpty(form.roleSrch.errors),
            key: [grid.roleList.page, grid.roleList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.roleSrch.getValues(),
                    page: grid.roleList.page,
                    size: grid.roleList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            roleId: (props: any) => {
                const { value } = props;
                return <Link to={`${URLS.ptli1004003s}/${value}`}>{value}</Link>;
            },
        },
    };

    const handler = {
        onGridCellClick: (cell: any) => {
            const { binding, rowValues } = cell;
            if (binding !== "roleId") return;

            setStore(pgeUid, { ...pgeStore, param: { ptlTpCd: rowValues.ptlTpCd, roleId: rowValues.roleId } });
        },
        onSrchBtnClick: form.roleSrch.handleSubmit(
            () => {
                grid.roleList.setPage(0);
                fetch.getRoleList.fetch(0);
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onNewBtnClick: () => navigate(`${URLS.ptli1004002s}`),
        onClear: () => {
            form.roleSrch.clearValues();
            grid.roleList.getData().length > 0 && grid.roleList.clearData();
        },
    };

    useEffect(() => {
        pgeStore?.form && form.roleSrch.setValues(pgeStore.form);
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.roleSrch.schema.roleId} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.roleList.grid}
                            data={fetch.getRoleList.data?.roleList}
                            render={render}
                            onCellClick={handler.onGridCellClick}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Layout.Button role="new" onClick={handler.onNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
